module.exports = __webpack_public_path__ + "static/media/24_tn.7f6dce9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/24_tn.jpg
// module id = 660
// module chunks = 0